import { useEffect, useState } from 'react'
import styled from 'styled-components'
import Image from "next/legacy/image";
import Link from 'next/link'
import { StyledButton } from 'src/styles/Button'
import { ContainerSmall } from 'src/styles/Container'
import { H1, SubHeading1, Detail } from 'src/styles/Typography'
import grabColor from 'src/utils/grabColor'
import AgentPositions from './AgentPositions'
import AgentsFormPortal from './AgentPortal'

function CareersAgentHero({ verticalSlug, hero, title, subTitle }) {
  const [loading, setLoading] = useState(false)
  const [age, setAge] = useState('')
  const [close, setClose] = useState(true)

  return (
    <HeroWrapper>
      <ContainerSmall>
        <HeroInner>
          <HeroLeft>
            <Title verticalSlug={verticalSlug}>
              Pick the <span className="aff-title">Career</span> that&apos;s right for{' '}
              <span>you</span>.
            </Title>
            <SubTitle>{subTitle}</SubTitle>
            <JobOpeningsBttn size="large" onClick={() => setClose((s) => !s)}>
              Start Selling Today
            </JobOpeningsBttn>
            {!close && <AgentsFormPortal setClose={setClose} />}
          </HeroLeft>
          <MainImageWrapper>
            <Image
              src={hero.photo.url}
              quality={30}
              alt={hero?.photo?.description || ''}
              layout="fill"
              objectFit="cover"
              priority
            />
          </MainImageWrapper>
        </HeroInner>
      </ContainerSmall>
    </HeroWrapper>
  )
}

export default CareersAgentHero

const JobOpeningsBttn = styled(StyledButton)`
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 352px;
    width: 100%;
    margin: 0 auto;
  }
`

const HeroWrapper = styled.div`
  position: relative;
`

const HeroInner = styled.div`
  display: grid;
  grid-template-columns: 408px 1fr;
  grid-gap: 0 80px;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1fr;
  }
`

const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  padding: 80px 0 124px;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 2rem 0;
  }
`

const Title = styled(H1)`
  margin: 0 0 1.5rem 0;
  span {
    color: ${grabColor('brand.dark')};
  }
  span.aff-title {
    color: ${({ theme, verticalSlug }) => theme.colors[verticalSlug].DEFAULT};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin: 0 0 1rem 0;
    font-size: 30px;
  }
`

const SubTitle = styled(SubHeading1)`
  margin: 0 0 2rem 0;
  max-width: 600px;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin: 0 0 1.5rem 0;
    font-size: 16px;
  }
`

const MainImageWrapper = styled.div`
  position: relative;
  margin: 0 0 0 -24px;
  width: calc(100% + 24px + 24px);
  min-height: 240px;
`

const FromWrapper = styled.form`
  width: 100%;
`

const LoadingFieldset = styled.fieldset`
  display: grid;
  grid-template-columns: 1fr 135px;
  border: 0;
  padding: 0;
  margin: 0;
  width: 100%;

  &[disabled] {
    opacity: 0.5;
  }
`
